/**
 * @description: 商品退货汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-sth-report">
        <div class="th-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="thTime">
                        <input type="text" class="form-control laydate-icon" v-model="thStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="thEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="thShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="thtypes"></select>
                </div>
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="th_goods_name">
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">退货总量:</label>
                <div class="list-total" ref="th_quantity"></div>
                <label class="list-label-4">进货总价:</label>
                <div class="list-total" ref="th_total"></div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitThTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getThExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="thList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="thExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='thExport_allcheck' @click='thExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='thExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='thExport_checkModel' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='thExport_checkModel' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='thExport_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='thExport_checkModel' value="quantity">
                            <label>退货数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='thExport_checkModel' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='thExport_checkModel' value="buying_price_total">
                            <label>进货价合计</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='thExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='thExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                th_goods_name: "",
                thStartTime: "",
                thEndTime: "",
                thExport_allcheck: false,
                c_thExport_allcheck: false,
                thExport_checkModel: [],
                thExport_checkData: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'quantity', 'buying_price', 'buying_price_total'],
                thExport_type: 1,
            }
        },
        watch: {
            thExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.thExport_checkModel.length >= this.thExport_checkData.length) {
                        this.thExport_allcheck = true;
                        this.c_thExport_allcheck = true;
                    } else {
                        this.thExport_allcheck = false;
                        this.c_thExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.thStartTime = moment().format('YYYY-MM-DD 08:00');
            this.thEndTime = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.typeList = [];
            this.getGoodsType();  // 商品类型
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.thStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.thEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.thStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.thEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.thTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.thStartTime = start.format('YYYY-MM-DD 08:00');
                    _this.thEndTime = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.thShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.thShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.innitThTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 商品类型
            getGoodsType: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {

                        }
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            result.unshift({ id: "0", name: "全部" });
                            $.each(result, function(k, v) {
                                _this.typeList.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.thtypes).html("");
                            $(_this.$refs.thtypes).select2({
                                data: _this.typeList,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },



            // 商品退货汇总报表表格
            innitThTable: function() {
                let _this = this;
                $(_this.$refs.thList).bootstrapTable('destroy');
                $(_this.$refs.thList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getThList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "13%"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "5%"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "13%"
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%"
                    }, {
                        field: "quantity",
                        title: "退货数量",
                        width: "8%"
                    }, {
                        field: "buying_price",
                        title: "进货单价",
                        width: "8%"
                    }, {
                        field: "buying_price_total",
                        title: "进货价合计",
                        width: "8%"
                    }]
                });
            },
            // 获取商品退货汇总报表
            getThList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.thShop).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.thStartTime,
                            "end_date": _this.thEndTime,
                            "shop_id": shop_id,
                            "goods_type": $(_this.$refs.thtypes).val() || '',
                            "goods_name": _this.th_goods_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGoodsRefundedSumList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                            $(_this.$refs.th_quantity).text(data.response.result.quantity_total);
                            $(_this.$refs.th_total).text(data.response.result.buying_price_total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getThExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/sumCommonExport?bill_type=refunded"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.thExport_checkModel = data.response.result.export_fields;
                                _this.thExport_type = data.response.result.export_type;
                            } else {
                                _this.thExport_checkModel = _this.thExport_checkData;
                                _this.thExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.thExport_alert)
                }, function() {
                    _this.exportThList();
                });
            },
            // 导出字段全选
            thExportCheckedAll: function() {
                let _this = this;
                _this.thExport_allcheck = _this.c_thExport_allcheck;
                if(!_this.thExport_allcheck) { // 实现全选
                    _this.thExport_checkModel = [];
                    _this.thExport_checkData.forEach(function(item) {
                        _this.thExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.thExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportThList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.thShop).val(),
                    goods_type = $(_this.$refs.thtypes).val() || '';
                let export_fields = JSON.stringify(_this.thExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/sumCommonExport?bill_type=refunded" +
                    "&start_date=" + _this.thStartTime +
                    "&end_date=" + _this.thEndTime +
                    "&shop_id=" + shop_id +
                    "&goods_type=" + goods_type +
                    "&goods_name=" + _this.th_goods_name +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.thExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>